export default __webpack_public_path__ + "static/media/at.aa4384cb.png";